// export default new Vue();
// export default {
//   install(Vue) {
//     const eventBus = new Vue();
//     Vue.prototype.$eventBus = eventBus;
//   },
// };
// import Vue from "vue";
// export const EventBus = new Vue();
// event-bus.js
import Vue from "vue";
const EventBus = new Vue();
export default EventBus;



// WEBPACK FOOTER //
// ./src/event-bus.js